var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconClip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.262 7.89c-1.048-.67-2.422.082-2.422 1.326v5.568c0 1.244 1.374 1.996 2.422 1.326l4.354-2.784a1.574 1.574 0 0 0 0-2.652L11.262 7.89ZM10.4 9.216v-.007l4.381 2.783s.002.003.002.008a.02.02 0 0 1-.002.008l-.003.003h-.002l-4.355 2.785-.003.002a.03.03 0 0 1-.002.001c-.002 0-.005 0-.009-.002a.022.022 0 0 1-.007-.006V9.216Zm.015-.015-.008.002-.007.006.015-.008Zm0 0 4.366 2.791a.06.06 0 0 0-.005-.004l-4.355-2.784-.003-.002-.003-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94 4.2A2.34 2.34 0 0 0 1.6 6.54v10.92a2.34 2.34 0 0 0 2.34 2.34h16.12a2.34 2.34 0 0 0 2.34-2.34V6.54a2.34 2.34 0 0 0-2.34-2.34H3.94Zm-.78 2.34c0-.43.349-.78.78-.78h16.12c.43 0 .78.35.78.78v10.92c0 .43-.35.78-.78.78H3.94a.78.78 0 0 1-.78-.78V6.54Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 24H0V0h24z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClip);
export default __webpack_public_path__ + "static/media/icon-clip.b707aa3815136655186764cbfcc99895.svg";
export { ForwardRef as ReactComponent };